export default "__VITE_ASSET__Coj0T4uK__"